export type ActionType = {
  type: string;
  payload?: any;
};

export const defaultAction = {
  type: '',
  payload: null,
};
